import Layout from '../../components/common/pageLayout'
import Header from '../../components/FAT/FATDetails/header'
import Filter from '../../components/FAT/FATDetails/filter'
import './fat.css'
import Comments from '../../components/FAT/FATDetails/comments'
import Log from '../../components/FAT/FATDetails/log'
import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import { toast } from 'react-toastify'
import { v3_add_fat_comment, v3_delete_fat_comment, v3_fat_comment_change_favourite_status, v3_fat_comment_status_update, v3_fat_detail } from '../../actions/v3/fat'
import Reply from '../../components/FAT/FATDetails/reply'

const Detail = () => {

    const location = useLocation();
    const { fatId } = location.state || {};
    const [data, setData] = useState(null)
    const [refresh, setRefresh] = useState(false)
    const [filterPayload, setFilterPayload] = useState({})
    const [selectedComment, setSelectedComment] = useState(null);
    const [activeTab, setActiveTab] = useState('log');

    const [selectedRevision, setSelectedRevision] = useState(null);
    const subject = data?.SUBJECT || data?.subject;
    const pageTitle = subject ? `FAT: ${subject}` : 'FAT';

    useEffect(() => {
        if (!fatId) {
            setData(null)
            return
        }
        v3_fat_detail(fatId, btoa(JSON.stringify(filterPayload))).then((res) => {
            if (res.status) {
                setData(res.result)
            }
        })
    }, [fatId, refresh, filterPayload])

    useEffect(() => {
        if (data?.revisions?.length > 0) {
            setSelectedRevision(data.revisions[data.revisions.length - 1])
        }
    }, [data])


    const onAddComment = (payload) => {
        v3_add_fat_comment({ ...payload, fatId }).then((res) => {
            if (res.status) {
                toast.success(res.result.message)
                setRefresh(!refresh)
                const modal = window.bootstrap.Modal.getInstance(document.getElementById(`commentModal`));
                if (modal) modal.hide();
            }

        })
    }
    const onChangeFavouriteStatus = (payload) => {
        v3_fat_comment_change_favourite_status({ ...payload, fatId }).then((res) => {
            if (res.status) {
                toast.success(res.result.message)
                setRefresh(!refresh)
            }
        })
    }

    const onDeleteComment = ({ commentId }) => {
        v3_delete_fat_comment({ fatId, commentId }).then((res) => {
            if (res.status) {
                toast.success(res.result.message)
                setSelectedComment(prev => prev === commentId ? null : prev)
                setRefresh(!refresh)
            }
            else {
                toast.error(res.error || 'Failed to delete comment')
            }
        }).catch((error) => {
            toast.error(error?.response?.data?.error || error?.message || 'Failed to delete comment')
        })
    }

    const onChangeFilter = (filterModel) => {
        setFilterPayload(filterModel)
    }


    const onChangeCommentStatus = async (model) => {
        v3_fat_comment_status_update(model).then(res => {
            if (res.status) {
                setRefresh(!refresh)
                toast.success(res.result.message)
                const modal = window.bootstrap.Modal.getInstance(document.getElementById(`statusUpdateModal-${model.commentId}`));
                if (modal) modal.hide();
            }
            else {
                toast.error(res.error || res.error.message)

            }
        })
    }
    return (
        <Layout title={pageTitle}>
            <div className="row">
                <div className="col-lg-12">
                    <div className="card" >
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-12 ">
                                    {data && <Header
                                        data={data}
                                        revision={selectedRevision}

                                    />}
                                    <Filter
                                        revisions={data?.revisions || []}
                                        onChangeFilter={onChangeFilter}
                                        commentCountByStatus={data?.commentCountByStatus}
                                    />

                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 ">
                                    <div className="Plan-details-report">
                                        <div className="row">
                                            <div className="col-md-7">

                                                {data && <Comments
                                                    selectComment={setSelectedComment}
                                                    data={selectedRevision}
                                                    fatId={fatId}
                                                    fatMeta={data}
                                                    onAddComment={onAddComment}
                                                    onUpdateStatus={onChangeCommentStatus}
                                                    onChangeFavouriteStatus={onChangeFavouriteStatus}
                                                    onDeleteComment={onDeleteComment}
                                                />}
                                            </div>
                                            <div className="col-md-5">
                                                <div className="widget">
                                                    <div className="widget-content">
                                                        <div className="column-wrap">
                                                            <div className="coloumn">
                                                                <div className="activity">
                                                                    <div className="d-flex gap-3 align-items-center mb-3">
                                                                        <h3
                                                                            className={`mb-0 ${activeTab === 'log' ? 'active' : ''}`}
                                                                            onClick={() => setActiveTab('log')}
                                                                        >
                                                                            Activity Log
                                                                        </h3>

                                                                        {selectedComment && (
                                                                            <h3
                                                                                className={`mb-0 ${activeTab === 'replies' ? 'active' : ''}`}
                                                                                onClick={() => setActiveTab('replies')}
                                                                            >
                                                                                Replies
                                                                            </h3>
                                                                        )}
                                                                    </div>
                                                                    {activeTab === 'log' && <Log
                                                                        fatId={fatId}
                                                                    />}

                                                                    {activeTab === 'replies' && < Reply
                                                                        fatId={fatId}
                                                                        commentId={selectedComment}
                                                                        revisionId={selectedRevision?.ID}

                                                                    />}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </Layout>

    )
}

export default Detail
